module.exports = __webpack_public_path__ + "img/footer-mockups-left.f7f88bb.png";